import React, { ComponentProps } from 'react';
import { ContentImage } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';

type ContentImageEditProps = {
  image: ContentImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: IForm;
};

export function ContentImageEdit({ image, form, cropping, viewportSwitch }: ContentImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('ContentImage');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="content-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
    />
  );
}

export const ContentImageEditView = asFetchableView(ContentImageEdit);
export type ContentImageEditView = ComponentProps<typeof ContentImageEditView>;
